import { Handlers } from '../../../types/actions/types';
import { JAVA_API_STATUS } from '../../../utils/axios-interceptor';
import { isEmpty } from '../../../utils/utils';
import { getLegalCaseDetailService, getLegalCasesDataService } from './service';

export const fetchLegalCasesData = async (payload: FetchLegalCasesPayload, handlers: Handlers) => {
    try {
        const res = await getLegalCasesDataService(payload);
        const responseData = res.data?.responseData;
        switch (responseData.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(res.data?.legalCasesResponse || {});
                return;
            case JAVA_API_STATUS.ERROR:
            default:
                handlers?.onError?.();
        }
    } catch (err) {
        handlers?.onError?.();
    }
};

// Not-found and every other non-SUCCESS responseCode are treated alike -- there's nothing the
// drawer can do differently for a 404 vs any other failure, so both fall to onError. So does a
// SUCCESS that carries no case: an empty detail is not a loaded one.
export const fetchLegalCaseDetailData = async (payload: FetchLegalCaseDetailPayload, handlers: Handlers) => {
    try {
        const res = await getLegalCaseDetailService(payload);
        const responseData = res.data?.responseData;
        // polus puts the case in the top-level `data`; `responseData` only holds the code and message.
        const legalCase = res.data?.data;
        switch (responseData.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                if (isEmpty(legalCase)) {
                    handlers?.onError?.();
                    return;
                }
                handlers?.onSuccess?.(legalCase);
                return;
            case JAVA_API_STATUS.ERROR:
            default:
                handlers?.onError?.();
        }
    } catch (err) {
        handlers?.onError?.();
    }
};

type FetchLegalCasesPayload = {
    assesseeOrgId: string;
    requestId: string;
};

type FetchLegalCaseDetailPayload = {
    assesseeOrgId: string;
    requestId: string;
    cino: string;
    entityId: string;
};
